import { styled as e, css as i } from "styled-components";
import { Icon as s } from "../Icon/index.js";
import { skeletonFadeAnimation as c } from "../../styles/animation.js";
import { BodyLight as p, CaptionLight as l, SmallLight as g } from "../../styles/typography/index.js";
import { Colors as r } from "../../styles/colors/index.js";
import { Theme as o, DarkThemeQuery as d, DarkNinjaThemeQuery as b } from "../../styles/themes/index.js";
const n = e.div`
  ${p};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  border-right: 1px solid rgb(${r.Silver});
  padding-right: 8px;
  margin-right: 12px;
  color: rgb(${o.colors.Alpha});

  ${d}, ${b} {
    border-right: 1px solid rgb(${r.Gray});
  }
`, y = e.span`
  ${l}

  margin-left: 8px;
  color: rgb(${r.Gray});
`, a = i`
  --rounded: 8px;
  display: flex;
  align-items: center;
  background-color: rgb(${o.colors.Juliet});
  border-radius: var(--rounded);
  border: 1px solid rgb(${o.colors.Golf});
  padding: 8px 8px 8px 12px;
  width: 100%;
  height: 40px;
  outline: none;
`, k = e.div`
  ${a}

  &:hover {
    background-color: rgb(${o.colors.Kilo});
    border: 1px solid rgb(${o.colors.Golf});
  }

  &:focus-within {
    border: 1px solid rgb(${o.colors.Alpha});
    background-color: rgb(${o.colors.Juliet});
    ${n} {
      border-color: rgb(${o.colors.Alpha});
    }
  }

  &[aria-disabled='true'] {
    background-color: rgb(${o.colors.Golf});
    border: 1px solid rgb(${r.Gray});
    ${n} {
      border-color: rgb(${r.Gray});
    }
  }

  &[aria-invalid='true'] {
    border: 1px solid rgb(${r.Red});
  }
`, G = e(s)`
  margin-left: 8px;
  font-size: 24px;
  color: rgb(${r.Gray});

  :first-child {
    margin-left: 0;
  }

  &[role='button'] {
    cursor: pointer;
  }

  &[data-icon-color='true'] {
    color: rgb(${o.colors.Brand});
  }
`, C = e.input`
  ${l}
  width: 100%;
  height: 100%;
  color: rgb(${o.colors.Alpha});
  caret-color: rgb(${o.colors.Brand});
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: rgb(${r.Gray});
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: rgb(${r.Gray});
  }

  &::-ms-input-placeholder {
    color: rgb(${r.Gray});
  }

  &:disabled {
    color: rgb(${o.colors.Alpha});
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: rgb(${o.colors.Alpha});
  }
`, I = e.div`
  ${a}
  ${c}

  :before {
    content: '-';
    display: block;
    color: transparent;
  }
`, t = i`
  ${g}
  display: inline-flex;
  align-items: center;
  width: 100%;
  margin-top: 4px;

  i {
    margin-right: 4px;
    font-size: 24px;
  }
`, T = e.span`
  ${t}
  color: rgb(${r.Red});
`, v = e.span`
  ${t}
  color: rgb(${r.Green});
`, w = e.span`
  ${t}
  color: rgb(${r.Blue});
`, A = e.span`
  ${t}
  color: rgb(${r.Mustard});
`, M = e.span`
  ${l}
  color: rgb(${r.Gray});
`;
export {
  y as CharacterCounter,
  M as CharsCountContainer,
  C as Input,
  G as InputIcon,
  n as PrefixContainer,
  A as TextInputAlertMessage,
  k as TextInputContainer,
  T as TextInputErrorMessage,
  I as TextInputSkeletonContainer,
  v as TextInputSuccessMessage,
  w as TextInputTipMessage,
  t as textInputBaseMessageStyle
};
